const TRACKING_ENDPOINT = "/api/track";

function currentPageUrl() {
  if (typeof window === "undefined") return "/pricing";
  return window.location.pathname || "/pricing";
}

function anonymousSession() {
  try {
    const key = "ig-pricing-analytics-session";
    const now = Date.now();
    let session = JSON.parse(window.sessionStorage.getItem(key) || "null");
    if (!session?.id || now - session.updated > 30 * 60 * 1000) session = {id:window.crypto.randomUUID()};
    session.updated = now;
    window.sessionStorage.setItem(key,JSON.stringify(session));
    return session.id;
  } catch { return null; }
}

export function trackInteraction(eventType, eventData = {}) {
  if (typeof window === "undefined" || !eventType) return;

  const payload = JSON.stringify({
    event_type: eventType,
    event_data: {...(eventData || {}), session_id:anonymousSession()},
    page_url: currentPageUrl(),
    timestamp: new Date().toISOString(),
  });

  // Extend this helper when adding pricing controls: define a stable event_type
  // in docs/TRACKING.md, then call trackInteraction from the control handler.
  fetch(TRACKING_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: payload,
    keepalive: true,
  }).catch(() => {});
}
